import type { Move } from '../../../schemas/move';

/**
 * Archetipi del Guerriero (manuale V1, rr. 3391-3397).
 *
 * 5 mosse di tipo `class_special`, una per ciascuna delle 5 razze standard.
 * Pattern razza-tematico standard (uguale al Ladro). Nessun caso speciale.
 */

const archetipoUmano: Move = {
  id: 'guerriero.archetipo-umano',
  name: 'Archetipo: Umano',
  type: 'class_special',
  classId: 'guerriero',
  trigger: 'Quando *discerni la realtà* durante una battaglia',
  description:
    'Aggiungi la domanda «*Quale sarà la prossima mossa di _____?*» alla lista. Puoi porre questa domanda riguardo un solo personaggio.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoElfo: Move = {
  id: 'guerriero.archetipo-elfo',
  name: 'Archetipo: Elfo',
  type: 'class_special',
  classId: 'guerriero',
  trigger: 'Quando attacchi con qualsiasi tipo di coltello, pugnale o spada a una mano',
  description: "Considera che l'arma abbia l'etichetta *precisa*.",
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoNano: Move = {
  id: 'guerriero.archetipo-nano',
  name: 'Archetipo: Nano',
  type: 'class_special',
  classId: 'guerriero',
  trigger: 'Quando bevi insieme a qualcuno',
  description: 'Puoi *parlamentare* con lui tirando+**COS** invece che +**CAR**.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoHalfling: Move = {
  id: 'guerriero.archetipo-halfling',
  name: 'Archetipo: Halfling',
  type: 'class_special',
  classId: 'guerriero',
  trigger: 'Una volta per combattimento',
  description: 'Puoi ritirare un singolo tiro per i danni (tuo o di qualcun altro).',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoMezzorco: Move = {
  id: 'guerriero.archetipo-mezzorco',
  name: "Archetipo: Mezz'orco",
  type: 'class_special',
  classId: 'guerriero',
  trigger:
    'Quando ti imbatti per la prima volta (a tua discrezione) in insegne, tattiche o storie militari',
  description: 'Puoi fare una domanda riguardo esse al GM, che ti risponderà sinceramente.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

export const guerrieroArchetypeMoves: readonly Move[] = [
  archetipoUmano,
  archetipoElfo,
  archetipoNano,
  archetipoHalfling,
  archetipoMezzorco,
] as const;
